import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PromoPopup from "@/components/PromoPopup";

import Home from "@/pages/Home";
import Store from "@/pages/Store";
import AreasServed from "@/pages/AreasServed";
import LocationsPage from "@/pages/Locations";
import Delivery from "@/pages/Delivery";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Rewards from "@/pages/Rewards";
import Education from "@/pages/Education";
import FAQPage from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import SelfCertify from "@/pages/SelfCertify";
import NotFound from "@/pages/NotFound";

// SEO blog pages
import BlogIndex from "@/pages/blog/BlogIndex";
import BestCannabisDispensary from "@/pages/blog/BestCannabisDispensary";
import HowToGetCard from "@/pages/blog/HowToGetCard";
import OutOfStateDispensary from "@/pages/blog/OutOfStateDispensary";
import HowToBuyMedicalCannabisDC from "@/pages/blog/HowToBuyMedicalCannabisDC";
import KhalifaKushDC from "@/pages/blog/KhalifaKushDC";
import AltSolCannabisDC from "@/pages/blog/AltSolCannabisDC";
import VisitingDWCGeorgiaAve from "@/pages/blog/VisitingDWCGeorgiaAve";

// Neighborhood landing pages (rendered via single dynamic route)
import NeighborhoodPage from "@/pages/NeighborhoodPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AgeGate />
        <PromoPopup />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Core pages */}
            <Route path="/store" element={<Store />} />
            <Route path="/menu" element={<Store />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/areas-served" element={<AreasServed />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/education" element={<Education />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/self-certify" element={<SelfCertify />} />

            {/* SEO blog pages from sitemap */}
            {/* SEO blog pages from sitemap */}
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/how-to-buy-medical-cannabis-dc" element={<HowToBuyMedicalCannabisDC />} />
            <Route path="/blog/how-to-get-medical-marijuana-card-dc" element={<HowToGetCard />} />
            <Route path="/blog/out-of-state-dispensary-dc" element={<OutOfStateDispensary />} />
            <Route path="/blog/best-cannabis-dispensary" element={<BestCannabisDispensary />} />
            <Route path="/blog/khalifa-kush-dc-dispensary" element={<KhalifaKushDC />} />
            <Route path="/blog/alt-sol-cannabis-dc" element={<AltSolCannabisDC />} />
            <Route path="/blog/visiting-district-wellness-center-dc" element={<VisitingDWCGeorgiaAve />} />

            {/* Legacy blog URLs — keep for SEO backwards compatibility */}
            <Route path="/best-cannabis-dispensary" element={<BestCannabisDispensary />} />
            <Route path="/how-to-get-medical-marijuana-card-dc" element={<HowToGetCard />} />
            <Route path="/out-of-state-dispensary-dc" element={<OutOfStateDispensary />} />
            <Route path="/how-to-buy-medical-cannabis-dc" element={<HowToBuyMedicalCannabisDC />} />

            {/* Neighborhood landing pages — single dynamic route */}
            <Route path="/:slug" element={<NeighborhoodPage />} />

            {/* Catch-all 404 — preserves URL, sets noindex */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
